import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { tr } from 'date-fns/locale';
import format from 'date-fns/format';
import axios from 'src/utils/axios';
import { isValid } from 'date-fns';
import { getUser } from 'src/utils/Common';


const BeratHesaplaDialog = ({ open, onClose,  onPreview }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [confirmOpen, setConfirmOpen] = useState(false);
  const SessionUser = getUser();

  const handleConfirmClick = () => {
    if (selectedDate) {
      setConfirmOpen(true);
    }
  };

  const handleActualConfirm = () => {
    const formattedDateForSQL = format(selectedDate, 'yyyy-MM-dd');
    axios
      .post(`SetYSBeratDate?HesapTarihi=${formattedDateForSQL}`)
      .then((response) => {
        if (response.data.ErrorCode === "0") {
          setSelectedDate(new Date());
          setConfirmOpen(false);
          onClose();
        } else {
          alert("İşlem sırasında bir hata oluştu.");
        }
      })
      .catch(() => {
        alert("Sunucuya bağlanırken bir hata oluştu.");
      });
  };

  const handleCancel = () => {
    //setSelectedDate(null);
    setConfirmOpen(false);
    onClose();
  };

  const handlePreview = () => {
    const formattedDateForSQL = format(selectedDate, 'yyyy-MM-dd');
    axios.get(`GetYSBeratOnizleme?HesapTarihi=${formattedDateForSQL}`)
      .then((response) => {
        if (response.data.length > 0) {
          onPreview(response.data)
          setSelectedDate(new Date());
          setConfirmOpen(false);
          onClose();
        } else {
          alert(format(selectedDate, 'dd-MM-yyyy') + " göre bir kayıt bulunamadı");
        }
      })
      .catch(() => {
        alert("Sunucuya bağlanırken bir hata oluştu.");
      });
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
      <Dialog open={open} onClose={handleCancel}>
        <DialogTitle>Berat Hesaplama</DialogTitle>
        <DialogContent>
          <DatePicker
            label="Tarih Seçiniz"
            value={selectedDate}
            onChange={(newDate) => setSelectedDate(newDate)}
            format="dd.MM.yyyy"  
          />
         {isValid(selectedDate) && (
            <Typography sx={{ mt: 2 }}>
              {format(selectedDate, 'dd.MM.yyyy')} tarihine göre berat hesaplatıyorsunuz.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="error">
            İptal
          </Button>
          <Button
            onClick={handlePreview}           
            color="secondary"          
          >
            Önizleme
          </Button>
          <Button
            onClick={handleConfirmClick}           
            color="primary"
            disabled={!selectedDate || !(SessionUser.Role_Id === 1 || SessionUser.Role_Id === 3)}
          >
            Hesapla
          </Button>
          
        </DialogActions>
      </Dialog>

      {/* Onay Dialogu */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
      >
        <DialogTitle>Onayla</DialogTitle>
        <DialogContent>
          <Typography>
            <strong>{selectedDate ? format(selectedDate, 'dd.MM.yyyy') : ''}</strong> tarihini seçtiniz.
          </Typography>
          <Typography sx={{ mt: 1 }}>
            Bu tarih baz alınarak beratlar <strong>Onay Bekleniyor</strong> durumunda eklenecek. Emin misiniz?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="error">
            İptal
          </Button>
          <Button onClick={handleActualConfirm} variant="contained" color="primary" style={{ backgroundColor: '#f57c00', color: '#fff' }}>
            Evet
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default BeratHesaplaDialog;
